export default [
  {
    path: window.pathApp + '/irrf',
    name: 'irrf',
    component: () => import('@/components/Irrf'),
    meta: {
      login: true,
      avisoCarrinho: true,
      title: "Informes de Contribuição",
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/irrf.js